import React from "react";
import styles from "../utils/gridStyles.js";
import dateFormat from 'dateformat';
import setHeaderRender from "../../components/app/setHeaderRender";

const setColumns = ({ modalDetail, allowWrite, changeDelay, updateSelectMultiRows, selectUnselectAllRows}) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
            cellRenderer: ({ value, data, onChange, disabled}) => ( <input type="checkbox" onChange={ onChange } checked={ value } disabled={ disabled }
            onClick={ () => { updateSelectMultiRows(data.code); } } /> ),
            headerCellRenderer: ({ checked, disabled, onChange }) => ( <input type="checkbox" onChange={ onChange } checked={ checked } disabled={ disabled } 
            onClick={selectUnselectAllRows} /> )
        },
        {
            id: "code",
            field: "code",
            label: "Code",
            width: '100px',
            sortable: false,
            resizable: true,
        },
        {
            id: "2",
            field: "domain",
            label: "MainDomain",
            width: '350px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'MainDomain', changeDelay, tableManager, column}) )
        },
        {
            id: "3",
            field: "keyLength",
            label: "keyLength",
            sortable: false,
        },
        {
            id: "4",
            field: "ca",
            label: "CA",
            sortable: false,
        },
        {
            id: "5",
            field: "sanDomains",
            label: "sanDomains",
            sortable: false,
        },
        {
            id: "6",
            field: "renew",
            label: "Renew",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.renew, "dd/mm/yyyy", true))
        },
        {
            id: "7",
            field: "Created",
            label: "Created",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.Created, "dd/mm/yyyy", true))
        }
    ];
};

export default setColumns;
